/** Types */

export const CREATE_CHARITY_REQUEST = "CREATE_CHARITY_REQUEST";
